import React from "react";
import Image from "gatsby-image";
import { useTeamPhotos } from "shared/Hooks/About/Team";
import { StreetwearImage } from "./StreetwearImage";

export const StreetwearData = () => {
  const images = StreetwearImage();
  const team_images = useTeamPhotos();
  return {
    color: "#0A0A0A",
    title: "Streetwear",
    seo:
      "Stworzyliśmy komunikację wizualną z elementami 3D, inspirowanymi streetwearem i kulturą hip-hopową oraz milionerskim życiem.",
    slug: "streetwear",
    hero: {
      title: "Definicja stylu miejskiego na bogato.",
      color: "#0A0A0A",
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.hero.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.detail.childImageSharp.fluid}
        />
      ),
    },
    list: {
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_bg.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_detail.childImageSharp.fluid}
        />
      ),
    },
    what_we_did: {
      title: "Koncepcja e-commerce w rytmie hip-hopu ",
      technologies: [
        "Sklep internetowy",
        "UX Workshops",
        "Identyfikacja wizualna",
        "CMS ",
      ],
      text:
        "Kultura hip-hop jest inspiracją dla cenionych, ekskluzywnych marek, które stały się dla wielu synonimem luksusu i najnowszej mody. Minimalizm, biel, czerń oraz złote popiersie antycznego filozofa w fullcapie to nasza definicja stylu miejskiego na bogato. Stworzyliśmy komunikację wizualną z elementami 3D, inspirowanymi streetwearem i kulturą hip-hopową oraz milionerskim życiem. Głównym zamysłem projektu jest motywacja użytkownika do „emocjonalnego zakupu”. Układ strony jest intuicyjny i przejrzysty, co sprzyja ekspozycji sprzedawanych produktów. ",
      list: [
        "Zrealizowaliśmy kompleksowy redesign marki",
        "Wykonaliśmy modele 3D brand heroes",
        "Opracowaliśmy schemat działań social media",
      ],
    },
    headers: {
      first:
        "Projekt e-commerce, z którego Rick Ross i Biggie Smalls byliby dumni",
    },
    full_images: {
      first: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.str_1f.childImageSharp.fluid}
          />
        ),
      },
      second: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.str_2f.childImageSharp.fluid}
          />
        ),
      },
      third: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.str_3f.childImageSharp.fluid}
          />
        ),
      },
      fourth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.str_4f.childImageSharp.fluid}
          />
        ),
      },
      fifth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.str_5f.childImageSharp.fluid}
          />
        ),
      },
      sixth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.str_6f.childImageSharp.fluid}
          />
        ),
      },
      seventh: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.str_7f.childImageSharp.fluid}
          />
        ),
      },
    },
    text_boxes: {
      first: {
        title: "Sklep z ulicznym flow",
        text:
          "Strona została zaprojektowana tak, aby odpowiadała stylowi marki i dopasowała się do grupy odbiorców. Wykonane zdjęcia przedstawiają klientom ofertę produktów dostępnych w sklepie.  Zachowana spójność i jednolitość elementów pokazuje markę w profesjonalny i unikatowy sposób.",
      },
      second: {
        title: "Autorski system dodawania treści i produtków",
        text:
          "Wykonany przez nas CMS pozwala na dodawanie nowych produtków do bazy sklepu i szybkie rozpoczęcie sprzedaży. Ponieważ połączenie sklepu z blogiem to najlepszy sposób na zdobywanie nowych klientów, ten sam system daje również możliwość uzupełnienia strony o nowe wpisy. ",
      },
      third: {
        title: "E-sklep w luksusowym stylu",
        text:
          "Złote motywy i elementy 3D takie jak rzeźby i popiersia nadają stronie niepowtarzalnego charakteru inspirowanego streetwearem i kulturą hip-hopową. Podkreślają także jej profesjonalizm i uwypuklają prestiżowe artykuły.",
      },
    },
    marketing: {
      counts: [
        {
          count: "20%",
          title: "Zwiększona konwersja",
        },
        {
          count: 2000,
          title: "Polubień w 1 miesiąc",
        },
        {
          count: "53%",
          title: "zwiększona sprzedaż",
        },
      ],
      team: [
        {
          name: "Patrycja Bilska",
          position: "Project Manager",
          image: (
            <Image alt="" fluid={team_images.Patrycja.childImageSharp.fluid} />
          ),
        },
        {
          name: "Rafał Skórka",
          position: "Frontend Developer",
          image: (
            <Image alt="" fluid={team_images.Rafal.childImageSharp.fluid} />
          ),
        },
        {
          name: "Patryk Białas",
          position: "Graphic designer",
          image: (
            <Image alt="" fluid={team_images.Patryk.childImageSharp.fluid} />
          ),
        },
        {
          name: "Rafał Krawiec",
          position: "Backend Developer",
          image: (
            <Image alt="" fluid={team_images.Krawczyk.childImageSharp.fluid} />
          ),
        },
        {
          name: "Jakub Żmuda",
          position: "Marketing Specialist",
          image: (
            <Image alt="" fluid={team_images.Kuba.childImageSharp.fluid} />
          ),
        },
        {
          name: "Jakub Furman",
          position: "Sales Manager",
          image: (
            <Image alt="" fluid={team_images.Furman.childImageSharp.fluid} />
          ),
        },
      ],
    },
  };
};
